import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';

import Application from '../components/app/Application';
import { withTranslation, WithTranslation } from 'react-i18next';

interface Props extends WithTranslation
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class RouteRoot extends React.Component<Props,State>
{
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.home')}</h1>
    </FormGroup>
    <FormGroup>
        <Link to="/tools">{t('titles.tools')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/links">{t('titles.links')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/about">{t('titles.about')}</Link>
    </FormGroup>
</Application>
        );
    }
};
export default withTranslation('common')(RouteRoot);
